let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("28WZh")).then(() => parcelRequire('k3HQ5'));